import { PolarAngleAxis, PolarGrid, Radar, RadarChart, ResponsiveContainer } from 'recharts'
import { tok } from './risk'

/** Module M1–M6 confidence profile. */
export function ModuleRadar({
  data,
  height = 230,
}: {
  data: { module: string; value: number }[]
  height?: number
}) {
  return (
    <ResponsiveContainer width="100%" height={height}>
      <RadarChart data={data} outerRadius="70%">
        <PolarGrid stroke={tok('--border')} />
        <PolarAngleAxis
          dataKey="module"
          tick={{ fill: tok('--faint'), fontSize: 11, fontFamily: 'var(--font-display)' }}
        />
        <Radar dataKey="value" stroke={tok('--stable')} fill={tok('--stable')} fillOpacity={0.22} />
      </RadarChart>
    </ResponsiveContainer>
  )
}
